<template>
    <div>
        <CCard class="mb-2"
        
            :class="(cliente.habilitado)?'cardHabil':'cardDeshab'"
            @mouseover="focus = true" 
            @mouseout="focus = false">
            <CCardHeader>

                <div class="card-header-actions float-left">
                    <CLink class="card-header-action btn-minimize" @click="expandirCliente">
                        <CIcon v-show="mostrarMas" :content="$options.freeSet.cilChevronTop" />
                        <CIcon v-show="!mostrarMas" :content="$options.freeSet.cilChevronBottom" />
                    </CLink>
                </div>
                <!--<CCardSubtitle class="mt-2 text-light">asdasdasd</CCardSubtitle>-->
                <CRow>
                    <CCol col="12">
                        <div class="mb-3" style="font-size: 13px;">
                            
                            <span v-tippy="getBaseTippy(`Cliente ${cliente.habilitado?'Habilidato':'Deshabilitado'}`)">
                                <CIcon style="color:green" name="cil-check-circle" v-show="cliente.habilitado"/>
                                <CIcon style="color:red" name="cil-x-circle" v-show="!cliente.habilitado" />
                            </span>
                            <span class="font-weight-bold">
                                <span v-tippy="{ placement: 'top',arrow: true, animation:'perspective', theme: 'google', followCursor : true, content: 'Nombre Cliente'}">
                                    {{ cliente.nombreCliente }}
                                </span>
                                <span v-tippy="{ placement: 'top',arrow: true, animation:'perspective', theme: 'google', followCursor : true, content: 'Rut Cliente'}">
                                    ({{ formatearRut(cliente.rutEmpresa) }})
                                </span>
                            </span>
                            <span>
                                
                                <span v-tippy="getBaseTippy(cliente.fechaCreacion)">Creado {{ formatFecha(cliente.fechaCreacion) }}</span>
                                
                                <span v-show="focus">
                                    <CButtonGroup size="sm" class="ml-2" v-show="!cliente.editar">
                                        <CButton color="warning" size="sm" style="height: 25px; padding-top: 0; padding-bottom: 0;"
                                            :content="'Editar Cliente'"                                            
                                            v-tippy="{ 
                                                placement: 'top',
                                                arrow: true, 
                                                arrowType: 'round', 
                                                animation:'perspective',
                                                theme: 'google',
                                                followCursor : true,
                                            }"
                                            @click="cliente.editar = true;editarCliente(cliente)"
                                        >
                                            <CIcon name="cil-pencil" style="height: 12px;" />
                                        </CButton>

                                        <CButton color="primary" v-show="false"
                                            style="height: 25px; padding-top: 0; padding-bottom: 0;"
                                            :content="'Configurar Cliente'"                                            
                                            v-tippy="{ 
                                                placement: 'top',
                                                arrow: true, 
                                                arrowType: 'round', 
                                                animation:'fade',
                                                theme: 'google',
                                                followCursor : true,
                                            }"
                                            @click="configurarCliente(cliente)"
                                            size="sm">
                                            <CIcon name="cilSettings" style="height: 12px;" />
                                        </CButton>

                                        <!--<CButton color="danger" 
                                        style="height: 25px; padding-top: 0; padding-bottom: 0;"
                                            :content="'Eliminar Cliente'"                                            
                                            v-tippy="{ 
                                                placement: 'top',
                                                arrow: true, 
                                                arrowType: 'round', 
                                                animation:'fade',
                                                theme: 'google',
                                                followCursor : true,
                                            }"
                                            @click="eliminarCliente(cliente)"
                                            size="sm" >
                                            <CIcon name="cil-x-circle" style="height: 12px;" />
                                        </CButton>-->
                                        
                                    </CButtonGroup>
                                </span>
                            </span>
                        </div>
                    </CCol>
                </CRow>
                <CRow>
                    <CCol col="5">
                        <CRow>
                            <CCol>
                                <div class="font-weight-bold">Productos:</div>
                                <div class="infoDetalle">
                                    <span><CIcon style="color:green" name="cil-check-circle" v-show="cliente.habilitarGesto"/>
                                        <CIcon style="color:red" name="cil-x-circle" v-show="!cliente.habilitarGesto" />
                                    </span><span>Gesto</span>
                                </div> 
                                <div class="infoDetalle">
                                    <span>
                                        <CIcon style="color:green" name="cil-check-circle" v-show="cliente.habilitarCompartida"/>
                                        <CIcon style="color:red" name="cil-x-circle" v-show="!cliente.habilitarCompartida" />
                                    </span><span>Compartida</span>
                                </div>
                                <div class="infoDetalle">
                                    <span>
                                        <CIcon style="color:green" name="cil-check-circle" v-show="cliente.habilitadoPortalEmpresa"/>
                                        <CIcon style="color:red" name="cil-x-circle" v-show="!cliente.habilitadoPortalEmpresa" />
                                    </span><span>Portal Empresa</span>
                                </div>
                            </CCol>
                            <CCol class="vertical-line">
                                <div class="font-weight-bold">BD's:</div>
                                <div class="infoDetalle">
                                    <span><CIcon style="color:green" name="cil-check-circle" v-show="cliente.tipoBdRemu"/>
                                        <CIcon style="color:red" name="cil-x-circle" v-show="!cliente.tipoBdRemu" />
                                    </span><span>Remu</span>
                                </div> 
                                
                                <div class="infoDetalle">
                                    <span><CIcon style="color:green" name="cil-check-circle" v-show="cliente.tipoBdConta"/>
                                        <CIcon style="color:red" name="cil-x-circle" v-show="!cliente.tipoBdConta" />
                                    </span><span>Conta</span>
                                </div> 
                            </CCol>

                        </CRow>
                        
                        
                    </CCol>
                    <CCol col="6">
                        <div>
                            <span class="font-weight-bold">Carpeta Raiz BD:</span>
                            <span v-tippy="{ placement: 'top',arrow: true, animation:'perspective', theme: 'google', followCursor : true, content: 'Carpeta Raiz BD'}">
                                ({{ cliente.carpetaRaiz }})
                            </span>
                        </div>
                        <div>
                            <span class="font-weight-bold">Nombre Carpeta BD</span>
                            <span v-tippy="{ placement: 'top',arrow: true, animation:'perspective', theme: 'google', followCursor : true, content: 'Nombre Carpeta BD'}">
                                ({{ cliente.rutaCarpetaBd }})
                            </span>
                        </div>
                        <div>
                            <span class="font-weight-bold">Id Unidad Drive</span>
                            <span v-tippy="{ placement: 'top',arrow: true, animation:'perspective', theme: 'google', followCursor : true, content: 'Id Unidad Drive'}">
                                ({{ (cliente.idUnidadDrive == null)?'No tiene google Drive asignado':cliente.idUnidadDrive }})
                            </span>
                        </div>
                    </CCol>
                    
                    
                </CRow>
            </CCardHeader>
            <CCollapse :show="mostrarMas" :duration="400">
                <CCardBody style="background-color: #F5F5F5;">
                    <CRow>
                        <CCol>
                            <CTabs>
                                <CTab active>
                                    <template slot="title">
                                        <CIcon name="cil-user" />
                                        <CBadge color="success" >{{cliente.usuarios.length}}</CBadge>
                                    </template>
                                    
                                    <CButton size="sm" class="mt-2 mb-1 btn-class" style="width:auto" @click="cliente.nuevoUsuario=!cliente.nuevoUsuario; monstrarMensajeCreacion = false;">
                                        <CIcon :content="$options.freeSet.cilSmilePlus" /> {{(cliente.nuevoUsuario)?"Cerrar Creación":"Nuevo Usuario"}}
                                    </CButton>
                                    <CargandoInfo :mostrarCarga="isLoadingUsuarios" :mensajeInfo="'Obteniendo Usuarios Clientes'" />
                                    <CRow style="padding: 10px;" v-show="!isLoadingUsuarios">
                                        <CCol  v-if="cliente.nuevoUsuario">
                                            <CrearUsuario :cliente="cliente" />
                                        </CCol>
                                        <CCol :col="(cliente.nuevoUsuario)?'7':'12'">
                                            <CRow v-if="cliente.usuarios.length <= 0">
                                                <CCol>
                                                    <center>No hay Usuarios Creados</center>
                                                </CCol>
                                            </CRow>
                                            <CRow v-for="usuario in cliente.usuarios" v-bind:key=usuario.idUsuario >
                                                <CCol>
                                                    <UsuarioInfo :usuario="usuario" :cliente="cliente" />
                                                </CCol>
                                            </CRow>
                                        </CCol>
                                    </CRow>
                                </CTab>
                                <CTab>
                                    <template slot="title" >
                                        <CIcon name="cil-settings" />
                                    </template>
                                    <CRow>
                                        <CCol>
                                            <ConfigCliente :cliente="cliente" />
                                        </CCol>
                                    </CRow>
                                </CTab>
                                <CTab>
                                    <template slot="title">
                                        <CIcon :content="$options.freeSet.cilLoopCircular" /><!--name="$options.freeSet.cilLoopCircular"-->
                                    </template>
                                    
                                    <CRow>
                                        <CCol>Aquí agregare el actualizar por empresa</CCol>
                                    </CRow>
                                </CTab>
                            </CTabs>
                            
                        </CCol>
                    </CRow>
                </CCardBody>
            </CCollapse>
        </CCard>

        
        <EditarCliente :cliente="cliente" />
    </div>
    


</template>

<script>
    import Vue from 'vue'
    import cons from "@/const";
    import axios from "axios";
    import { freeSet } from "@coreui/icons";

    
    import { format, formatDistance, formatRelative, subDays } from "date-fns";
    import es from "date-fns/locale/es";
    window.locale = "es";

    
    import EditarCliente from "../Modals/EditarCliente"
    import CrearUsuario from './CrearUsuario'
    import UsuarioInfo from './UsuarioInfo'
    import ConfigCliente from './ConfigCliente'
    

    export default {
        name: "ClienteInfo",
        freeSet,
        props: {
            cliente: Object
        },
        components: {
            EditarCliente,
            CrearUsuario,
            UsuarioInfo,
            ConfigCliente
        },
        data() {
            return {
                paginaActual: 1,

                baseUrl: cons.protocolo + "://" + cons.ipServer + cons.puerto,

                tokenLogin: JSON.parse(this.$cookie.get("userLogginTokenAdmin")).tokenUsuario,

                mostrarMas: false,
                focus: false,

                isLoadingUsuarios: false

            };
        },
        created: function () {},
        beforeMount() {
        },
        mounted() {},
        methods: {
            formatearRut: function(rut){
                var rutaFormatear = rut.replace(/^0+|[^0-9kK]+/g, '').toUpperCase();
                let len = rutaFormatear.length - 1;
                if (len > 3) {
                    let dv = rutaFormatear[len];
                    let beforeDv = rutaFormatear.substring(0, len).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
                    rutaFormatear = beforeDv + '-' + dv;
                }
                return rutaFormatear;
            },
            formatFecha: function(fecha){
                //return format(new Date(fechaDoc), 'EEE d LLL/yy H:mm:ss', {locale: es})//'dd/MM/yyyy' 'EEE d LLL/yy H:mm:ss'
                if(fecha != null)
                    return formatDistance(new Date(fecha), new Date(), { addSuffix: true, locale: es})//.isSame(moment().clone().startOf('day'), 'd')
                else
                    return "Nunca"
                
            },
            configurarCliente: function(){

            },
            eliminarCliente: function(){
                this.mostrarNotificaciones(1, "Eliminado")
            },
            editarCliente: function(cliente){
                cliente.respaldocliente = {
                    'nombreCliente': cliente.nombreCliente.normalize("NFD").replace(/[\u0300-\u036f]/g, ""),
                    'rutEmpresa': cliente.rutEmpresa,
                    'rutaCarpetaBd': cliente.rutaCarpetaBd,
                    'idUnidadDrive': cliente.idUnidadDrive,
                    'habilitado': cliente.habilitado,
                    "habilitarGesto": cliente.habilitarGesto,
                    "habilitarCompartida": cliente.habilitarCompartida,
                    "rutaCarpetaDrive": cliente.rutaCarpetaDrive,
                    "carpetaDefectoDrive": cliente.carpetaDefectoDrive,
                    "habilitadoPortalEmpresa": cliente.habilitadoPortalEmpresa,
                    "carpetaRaiz": cliente.carpetaRaiz,
                    "tipoBdRemu": cliente.tipoBdRemu,
                    "tipoBdConta": cliente.tipoBdConta
                }

            },
            expandirCliente: function(){
                this.mostrarMas = !this.mostrarMas
                if(this.mostrarMas){
                    this.getUsuarios()
                }
            },
            getUsuarios: function(){
                this.isLoadingUsuarios = true
                var url = this.baseUrl + "/get_usuarios_cliente";

                axios({
                    method: "POST", 
                    "url": url,
                    "data": {
                        "idCliente": this.cliente.idCliente
                    },
                    "headers": {
                        'Authorization': this.tokenLogin
                    }
                }).then(result => {
                    this.cliente.usuarios = result.data;
                    this.isLoadingUsuarios = false
                    
                }, error => {
                    let mensaje = `Problema al obtener Clientes, ${error}`
                    this.isLoadingUsuarios = false
                })
                .finally(() => {
                });
            },


        },
    };
</script>

<style>

    .cardHabil{
        border-color: green;
    }
    .cardDeshab{
        border-color: red;
    }

    .vertical-line {
        border-left: 1px solid rgb(37, 37, 43);
        height: 100px; /* Ajusta la altura de la línea */
        margin-left: 20px; /* Ajusta el margen si es necesario */
    }
</style>